module.exports = __webpack_public_path__ + "static/media/8.20053fce.png";